module.exports = __webpack_public_path__ + "img/BAVARIA.0957b2bf.jpg";